module.exports = __webpack_public_path__ + "img/57ne.8069b122.svg";